import { getDomainConfig } from '@raisin/cp-utils';

export const getInterestRateType = (locale: string) =>
  getDomainConfig(locale).interestRateType || 'interest_rate_nominal';
